import { jsx } from "react/jsx-runtime";
import PeopleIcon from "@mui/icons-material/People";
import { validateTidalLicense } from "../../base/index.js";
function People(props) {
  return /* @__PURE__ */ jsx(
    PeopleIcon,
    {
      "data-testid": "People",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "People",
      "data-tidal-icon-meta": "people,persona"
    }
  );
}
People.tidalIconMeta = {
  categories: "people,persona",
  name: "People"
};
validateTidalLicense();
export {
  People
};
//# sourceMappingURL=People.js.map
